function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { SearchBox } from '@fluentui/react';
import SpzaComponent from './spzaComponent';
import { Constants } from './../utils/constants';
import { deepEqual } from './../utils/objectUtils';
import { getOptionIndex, getContainerAriaLabel, getContainerClassName, getOptionClassName, CONTAINER_ROLE, isHoverEvent, getFilteredOptions, isOptionSelected } from './../utils/richTextDropDownUtils';
import classNames from 'classnames';
export class RichTextDropDown extends SpzaComponent {
    renderValueMethod(item) {
        if (this.props.renderValueHandle) {
            return this.props.renderValueHandle(item);
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "item",
            children: /*#__PURE__*/ _jsx("span", {
                className: "text-item",
                children: item.text
            })
        });
    }
    renderOptionMethod(item) {
        if (this.props.renderOptionHandle) {
            return this.props.renderOptionHandle(item);
        }
        if (this.isSearchEnabled() && this.state.searchValue.length) {
            const searchValue = this.state.searchValue;
            const countryName = item.text;
            const start = countryName.toLowerCase().indexOf(searchValue.toLowerCase());
            const end = start + searchValue.length - 1;
            return /*#__PURE__*/ _jsxs("div", {
                className: "item",
                children: [
                    countryName.substr(0, start),
                    /*#__PURE__*/ _jsx("b", {
                        className: "item-search",
                        children: countryName.substr(start, end - start + 1)
                    }),
                    countryName.substr(end + 1)
                ]
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "item",
            children: item.text
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!deepEqual(this.props.options, nextProps.options) || !deepEqual(this.props.value, nextProps.value)) {
            this.setState({
                value: nextProps.value
            });
        }
    }
    openDropDown(eventType) {
        var _this_dropdownElement;
        (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.classList.remove('outline-focus');
        if (this.shouldSkipEventHandle(eventType)) {
            return;
        }
        this.setState({
            isOpen: true
        }, ()=>{
            if (this.isHoverEnabled()) {
                var _this_dropdownElement;
                (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.focus();
            }
            if (this.isSearchEnabled() && this.searchBoxElement) {
                this.searchBoxElement.focus();
            }
        });
        if (this.state.value) {
            this.setState({
                highLightOption: this.state.value
            });
        }
        // reset to true everytime dropdown opens
        this.shouldCloseOnBlur = true;
    }
    closeDropDown(eventType) {
        var _this_dropdownElement;
        if (this.shouldSkipEventHandle(eventType)) {
            return;
        }
        (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.setAttribute('aria-expanded', 'false');
        this.setState({
            isOpen: false,
            searchValue: ''
        });
        this.removeTabIndex();
        this.lastFocusableIndex = -1;
        this.lastFocusableGroupIndex = -1;
        // reset to true everytime dropdown closes
        this.shouldCloseOnBlur = true;
    }
    onBlur(eventType, event) {
        var _this_dropdownElement;
        (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.classList.add('outline-focus');
        // after change onMouseDown to onClick for menu item need not to close dropdown.
        // header menu items have tabindex and this onBlur method fires before item onClick handler
        if (this.isHoverEnabled() || this.isEventOnSearch(event)) {
            return;
        }
        if (this.shouldCloseOnBlur) {
            this.closeDropDown(eventType);
            if (this.props.onBlurHandle) {
                this.props.onBlurHandle();
            }
        }
        // reset to true everytime dropdown loses focues
        this.shouldCloseOnBlur = true;
    }
    isHoverEnabled() {
        return this.props.hoverEnabled && this.userInteractionType === Constants.UserInteractionType.Mouse || !this.props.isDisabled;
    }
    isSearchEnabled() {
        return (this.props.searchEnabled || false) && !this.props.isDisabled;
    }
    isEventOnSearch(event) {
        if (event.type === Constants.EventType.Click) {
            return this.isSearchEnabled() && event.target.tagName === Constants.HTMLElements.INPUT;
        } else if (event.type === Constants.EventType.Blur) {
            return this.isSearchEnabled() && event.currentTarget.contains(event.relatedTarget) && (event.relatedTarget.tagName === Constants.HTMLElements.INPUT || Constants.HTMLElements.BUTTON);
        } else {
            return false;
        }
    }
    shouldSkipEventHandle(eventType) {
        return isHoverEvent(eventType) && !this.isHoverEnabled();
    }
    removeTabIndex() {
        if (this.lastFocusableIndex !== -1 && this.lastFocusableGroupIndex !== -1) {
            const previousMenu = document.getElementsByClassName('richTextDropDown')[this.lastFocusableGroupIndex];
            if (previousMenu) {
                const previousMenuItem = previousMenu.getElementsByClassName('c-menu-item')[this.lastFocusableIndex];
                if (previousMenuItem) {
                    previousMenuItem.removeAttribute('tabIndex');
                }
            }
        }
    }
    resetFocus(targetIndex) {
        this.removeTabIndex();
        const richMenus = document.getElementsByClassName('richTextDropDown');
        if (richMenus) {
            for(let i = 0; i < richMenus.length; i++){
                if (richMenus[`${i}`].getAttribute('aria-expanded') === 'true') {
                    this.lastFocusableGroupIndex = i;
                    break;
                }
            }
        }
        this.lastFocusableIndex = targetIndex;
        const currentMenu = document.getElementsByClassName('richTextDropDown')[this.lastFocusableGroupIndex];
        if (currentMenu) {
            const currentMenuItem = currentMenu.getElementsByClassName('c-menu-item')[`${targetIndex}`];
            if (currentMenuItem) {
                currentMenuItem.setAttribute('tabIndex', '0');
                currentMenuItem.focus();
            }
        }
    }
    onKeyDown(event, eventType) {
        let isEventDefaultEnabled = false;
        const options = this.props.options;
        const optionLength = this.props.options.length;
        if (this.props.isDisabled) return;
        switch(event.keyCode){
            case Constants.SystemKey.Up:
                if (event.altKey) {
                    this.toggleOpen(eventType);
                } else {
                    if (!this.state.isOpen) {
                        let index = getOptionIndex(options, this.state.value);
                        index = index >= 0 ? index : 0;
                        const prevItemIndex = (index - 1 + optionLength) % optionLength;
                        const value = options[`${prevItemIndex}`];
                        this.setState({
                            value: value
                        });
                        this.props.onChangeHandle(value, options);
                    } else {
                        this.shouldCloseOnBlur = false;
                        if (!this.state.highLightOption) {
                            this.setState({
                                highLightOption: options[optionLength - 1]
                            });
                        } else {
                            const itemIndex = getOptionIndex(options, this.state.highLightOption);
                            const prevItemIndex = (itemIndex - 1 + optionLength) % optionLength;
                            this.setState({
                                highLightOption: options[`${prevItemIndex}`]
                            });
                            this.resetFocus(prevItemIndex);
                        }
                    }
                }
                break;
            case Constants.SystemKey.Down:
                if (event.altKey) {
                    this.toggleOpen(eventType);
                } else {
                    if (!this.state.isOpen) {
                        let index = getOptionIndex(options, this.state.value);
                        index = index >= 0 ? index : 0;
                        const nextItemIndex = (index + 1) % optionLength;
                        const value = options[`${nextItemIndex}`];
                        this.setState({
                            value: value
                        });
                        this.props.onChangeHandle(value, options);
                    } else {
                        this.shouldCloseOnBlur = false;
                        if (!this.state.highLightOption) {
                            this.setState({
                                highLightOption: options[0]
                            });
                        } else {
                            const itemIndex = getOptionIndex(options, this.state.highLightOption);
                            const nextItemIndex = (itemIndex + 1) % optionLength;
                            this.setState({
                                highLightOption: options[`${nextItemIndex}`]
                            });
                            this.resetFocus(nextItemIndex);
                        }
                    }
                }
                break;
            case Constants.SystemKey.Enter:
            case Constants.SystemKey.Space:
                this.toggleOpen(eventType);
                break;
            case Constants.SystemKey.Esc:
                var _this_dropdownElement;
                (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.focus();
                this.closeDropDown(eventType);
                break;
            case Constants.SystemKey.Tab:
                var _this_dropdownElement1;
                isEventDefaultEnabled = true;
                (_this_dropdownElement1 = this.dropdownElement) === null || _this_dropdownElement1 === void 0 ? void 0 : _this_dropdownElement1.focus();
                this.closeDropDown(eventType);
                break;
        }
        if (!isEventDefaultEnabled && !this.isSearchEnabled()) {
            event.preventDefault();
        }
    }
    onDropdownClicked(eventType, event) {
        if (this.state.isOpen && !this.isEventOnSearch(event)) {
            this.closeDropDown(eventType);
        } else if (!this.props.isDisabled) {
            this.openDropDown(eventType);
        }
        if (eventType === Constants.EventType.Click) {
            this.userInteractionType = Constants.UserInteractionType.Mouse;
        }
    }
    onOptionClicked(option, eventType) {
        this.setState({
            value: option
        });
        this.props.onChangeHandle(option, this.props.options);
        this.closeDropDown(eventType);
    }
    toggleOpen(eventType) {
        if (!this.state.isOpen) {
            this.openDropDown(eventType);
        } else {
            var _this_dropdownElement;
            if (this.state.highLightOption) {
                this.onOptionClicked(this.state.highLightOption, eventType);
            }
            (_this_dropdownElement = this.dropdownElement) === null || _this_dropdownElement === void 0 ? void 0 : _this_dropdownElement.focus();
            this.closeDropDown(eventType);
        }
    }
    sortOptions(options) {
        const sortedOptions = options.sort((a, b)=>{
            const titleA = a.title.toUpperCase();
            const titleB = b.title.toUpperCase();
            return titleA < titleB ? 1 : titleA > titleB ? -1 : 0;
        });
        return sortedOptions;
    }
    renderImpl() {
        const labelPrefix = this.props.dropdownLabel || (this.dropdownElement && this.dropdownElement.innerText ? this.dropdownElement.innerText.split('\n')[0].trim() : '');
        let options = !this.isSearchEnabled() ? this.props.options : getFilteredOptions(this.props.options, this.state.searchValue);
        options = this.props.isSorted ? this.sortOptions(options) : options;
        const dropdownClass = classNames({
            [getContainerClassName(this.props.className)]: true,
            disabledDropdown: this.props.isDisabled
        });
        const selectedOption = this.state.value ? this.state.value.text + ' selected' : this.context.loc('Menu_Aria_Label', 'Menu');
        return /*#__PURE__*/ _jsxs("div", {
            className: dropdownClass,
            onBlur: (event)=>this.onBlur(event.type, event),
            onTouchStart: ()=>this.userInteractionType = Constants.UserInteractionType.Touch,
            onClick: (event)=>this.onDropdownClicked(event.type, event),
            onMouseEnter: (event)=>this.openDropDown(event.type),
            onMouseLeave: (event)=>this.closeDropDown(event.type),
            onKeyDown: (event)=>this.onKeyDown(event, event.type),
            suppressContentEditableWarning: true,
            tabIndex: 0,
            "aria-expanded": this.state.isOpen,
            "aria-label": getContainerAriaLabel(labelPrefix) + ' ' + selectedOption,
            ref: (element)=>this.dropdownElement = element,
            role: CONTAINER_ROLE,
            "aria-haspopup": "listbox",
            children: [
                !this.state.isOpen || this.state.isOpen && !this.isSearchEnabled() ? /*#__PURE__*/ _jsxs("a", {
                    className: "valueBox",
                    "aria-hidden": true,
                    children: [
                        this.renderValueMethod(this.state.value),
                        /*#__PURE__*/ _jsx("div", {
                            className: "toggle",
                            "aria-hidden": true,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(SearchBox, {
                    placeholder: this.context.loc('Search_Placeholder'),
                    value: this.state.searchValue,
                    onEscape: (event)=>this.closeDropDown(event.type),
                    onClear: ()=>{
                        this.setState({
                            searchValue: ''
                        });
                    },
                    onChange: (event, newValue)=>this.setState({
                            searchValue: newValue
                        }),
                    onSearch: (newValue)=>this.setState({
                            searchValue: newValue
                        }),
                    disableAnimation: true,
                    disabled: this.props.isDisabled,
                    componentRef: (element)=>this.searchBoxElement = element
                }),
                this.state.isOpen && /*#__PURE__*/ _jsx("ul", {
                    className: "c-menu",
                    role: "listbox",
                    children: options.map((option, index)=>/*#__PURE__*/ _jsxs("li", {
                            role: "option",
                            className: getOptionClassName(option, this.state.highLightOption),
                            onClick: (event)=>this.onOptionClicked(option, event.type),
                            onTouchEnd: (event)=>this.onOptionClicked(option, event.type),
                            onMouseEnter: ()=>this.setState({
                                    highLightOption: option
                                }),
                            "aria-selected": isOptionSelected(option, this.state.highLightOption),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "value",
                                    children: this.renderOptionMethod(option)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "placeholder"
                                })
                            ]
                        }, index))
                })
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "dropdownElement", void 0), _define_property(this, "searchBoxElement", void 0), _define_property(this, "lastFocusableIndex", -1), _define_property(this, "lastFocusableGroupIndex", -1), _define_property(this, "shouldCloseOnBlur", void 0), _define_property(this, "userInteractionType", Constants.UserInteractionType.Mouse);
        this.state = {
            value: this.props.value,
            searchValue: ''
        };
        this.renderValueMethod = this.renderValueMethod.bind(this);
        this.renderOptionMethod = this.renderOptionMethod.bind(this);
    }
}
RichTextDropDown.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
